import StickyNavbar from '../Navbar/Navbar';
import './BannerComponent.scss';
export default function BannerComponent() {
    return (
        <section className='banner-section tw-relative'>
            <div className='banner-bg'>
                <div className="logo-img">
                    <img alt='Kakariki Coffee' className='banner-logo' src='/images/banner/kakariki-logo.png' />
                    <p className='tw-uppercase banner-name tw-mt-4'>Kakariki Coffee</p>
                </div>
                <div className='hidden md:block'>
                    <StickyNavbar className="absolute inset-x-0 bottom-0" />
                </div>
            </div>

        </section>
    );
}